/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import UI_CONSTANTS from '../../constants/uiConstants';

const PaddedContent = (props) => (
  <div className="cmp-paddedcontent util-application-frame-forcards-padding" style={{ height: props.height, maxWidth: props.maxWidth }}>
    {props.children}
  </div>
);
PaddedContent.propTypes = {
  children: PropTypes.any,
  height: PropTypes.string,
  maxWidth: PropTypes.any,
};

export const MediumWidthPaddedConent = (props) => (
  <div className="cmp-paddedcontent util-application-frame-nocards-padding" style={{ height: props.height, maxWidth: UI_CONSTANTS.mediumContentWidth }}>
    {props.children}
  </div>
);
MediumWidthPaddedConent.propTypes = {
  children: PropTypes.any,
  height: PropTypes.string,
};

export const NoCardsPaddedContent = (props) => (
  <div className="cmp-paddedcontent util-application-frame-nocards-padding" style={{ height: props.height }}>
    {props.children}
  </div>
);
NoCardsPaddedContent.propTypes = {
  children: PropTypes.any,
  height: PropTypes.string,
};

export default PaddedContent;
